import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { TariffCard } from 'console/sim/shared/compare-tariff/tariff-card';
import { useNavigate, useParams } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/effect-cards';
import { Content } from 'console/sim/context';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { CompareCards } from 'shared/components/compare-card';
import { isUpgradeTariff } from 'console/sim/utils';
import { select_billed_sim_card } from 'console/sim/utils/select-sim';
export function CompareSimTariff() {
    const { sim_tariffs } = useContext(Content);
    const { descriptions, error, loading } = sim_tariffs;
    const navigate = useNavigate();
    const onChooseTariff = useCallback((id) => navigate(id), [navigate]);
    const { sim_id, operator } = useParams();
    const billed_sim = useAppSelector((state) => select_billed_sim_card(state, sim_id == null || operator == null
        ? null
        : { id: sim_id, operator }));
    const current_tariff = billed_sim?.tariff_state.current ?? null;
    const onChoose = useCallback((tariff) => () => {
        onChooseTariff(tariff);
    }, [onChooseTariff]);
    const component = useCallback((tariff) => (_jsx(TariffCard, { tariff: tariff, isCurrent: current_tariff != null ? current_tariff == tariff.id : false, isUpgrade: current_tariff != null
            ? isUpgradeTariff(current_tariff, tariff.id)
            : false, onChoose: onChoose(tariff.id), loading: loading })), [loading, current_tariff, onChoose]);
    return (_jsx(ErrorBoundary, { children: _jsx(CompareCards, { data: descriptions, component: component, error: error }) }));
}
